import { Overlay, Tooltip } from '@repo/components/tooltips';
import cn from 'classnames';
import React, { MouseEventHandler } from 'react';
import styles from './ColorOption.module.scss';
import { GroupColorHex, GroupColorLabel } from '@repo/utils/models/Group';

export function ColorOption({
  hex,
  label,
  active,
  onMouseDown,
  placement = 'left',
}: {
  hex?: GroupColorHex;
  label: GroupColorLabel;
  active: boolean;
  onMouseDown: MouseEventHandler;
  placement?: 'left' | 'right';
}) {
  return (
    <Tooltip
      placement={placement}
      overlay={<Overlay className={cn(styles[`tooltip${placement}`])}>{label}</Overlay>}
      delay
    >
      <div
        className={cn(styles.color, !hex && styles.autoColor, active && styles.active)}
        onMouseDown={onMouseDown}
        style={{ '--bgColor': hex ? hex : 'var(--textPrimary)' } as React.CSSProperties}
      />
    </Tooltip>
  );
}
